

<!-- Start of Quick search common component -->
    <app-quick-search 
        [DefaultFilterArray]="DefaultFilterArray"
        [QuickSearchFilterArray]="quickFilterArray"
        (updateDefaultArray)="updateDefaultArray($event)"
        (clearQuickSearch)="clearQuickSearch($event)">
    </app-quick-search>
<!-- End of Quick search common component -->


<!--Filter Code  -->
<div class="col-lg-12 nopadding">
    <app-filter-panel id="filter_fdid" [GridColumns]="GridColumns" [DefaultFilterArray]="DefaultFilterArray" (FilterEvent)="FilterApplyFilterEvent($event)" (FilterEventClearSymbol)="FilterEventClearSymbol($event)">
    </app-filter-panel>
</div>

<div class="col-lg-12 nopadding">
    @if(isLoadingResults){
    <div class="example-loading-shade">
        @if(isLoadingResults){
        <mat-spinner></mat-spinner>}
      </div>}
<div class="card" (mouseup)="commonColService.stopDragging()" (mouseleave)="commonColService.stopDragging()">
  <p-contextMenu #cm [model]="commonColService.menuItems" appendTo="body" styleClass="column-context-menu"></p-contextMenu> 
    <p-table 
            id="ptable_fdid"
            [columns]="commonColService.selectedColumns" 
            [value]="fdidData" 
            [class.table-frozen]="commonColService.isFrozenColumns"
            [paginator]="true" 
            [resizableColumns]="true"
            columnResizeMode="expand" 
            appendTo="body" 
            [rows]="rowcount" 
            [pageLinks]="constantService.DEFAULT_PAGELINKS" 
            [totalRecords]="totalRecords" 
            alwaysShowPaginator="true"
            (onLazyLoad)="changePage($event)"
            [lazy]="true"
            paginatorPosition="both"
            sortMode="multiple" 
            [rowsPerPageOptions]="constantService.DEFAULT_ROWSPERPAGEOPTION"
            [scrollable]="true" 
            scrollHeight="60vh"
            [reorderableColumns]="true"
            (onColReorder)="commonColService.onColumnsReordered($event, dt1)"
            styleClass="fdidtableData"
            #dt1 >
        <ng-template pTemplate="caption">
            <div class="padtb10">
                <button pButton id="btn_add_fdid" type="button" class="pull-left cls-button" (click)="onClickAddFDID()">Add Account Number/Given Name</button>
            </div>
        </ng-template>
        <ng-template id="tmplt_fdid_msg" pTemplate="emptymessage" let-columns>
            <tr>
              <td [attr.colspan]="columns.length">
                {{constantService.NO_RECORDFOUND_MSG}}
              </td>
            </tr>
          </ng-template>
        <ng-template id="tmplt_fdid_header" pTemplate="header" let-columns>
            <tr>
                <th id="columns" style="width:7em" pFrozenColumn
                [frozen]= "commonColService.hasFrozenColumns()" style="cursor: default !important;">Action</th>
                @for (col of columns; track col + '-'+ $index){
                <th [attr.id]="'col-' + col.field" pFrozenColumn pReorderableColumn
                    [frozen]="col.frozen" alignFrozen="left"
                    [style.left]="col.frozen ? $any(col).stickyLeft : ''"
                    [style.background-color]="col.frozen && !commonColService.selectedFields.includes(col.field) ? 'sortClass' : null"
                    [class.selected-header]="commonColService.selectedFields.includes(col.field)"
                    (mousedown)="commonColService.onHeaderMouseDown($event, col.field)"
                    (mouseenter)="commonColService.onHeaderMouseEnter(col.field)"
                    (contextmenu)="commonColService.onHeaderContextMenu($event, col.field,contextMenuItems, dt1)">
                    <div class="header-cell-content">
                    <span class="excel-cursor-span">
                    {{col.header}}
                    </span>
                    @if(col.frozen) {
                    <i class="pi pi-lock" style="font-size: 0.85rem; color: #000; margin-left: 4px;"></i>
                    }
                    </div>
                </th>}
            </tr>
        </ng-template>
        <ng-template pTemplate="body" id="tmplt_fdid_body" let-rowData let-ri="rowIndex" let-columns="columns">
            <tr>
                <td style="text-align:center" pFrozenColumn [frozen]= "commonColService.hasFrozenColumns()">
                    <p-button [style]="{'width':'20px'}" class="pi pi-xxx" or class="fa fa-xxx" matTooltip="View" [matTooltipShowDelay]="1000" matTooltipPosition="above"
                        appendTo="body" icon="fa fa-xxx fa-eye" (click)="onRowSelect('View', rowData);"></p-button>
                    <p-button [style]="{'width':'20px'}" class="pi pi-xxx" or class="fa fa-xxx" matTooltip="Edit"
                        [matTooltipShowDelay]="1000" matTooltipPosition="above" appendTo="body" icon="fa fa-xxx fa-edit"
                        (click)="onClickEditFDID(rowData)"></p-button>
                    <p-button [id]="'DeleteBtn'+rowData['id']"  class="pi pi-xxx" or class="fa fa-xxx" matTooltip="Delete" matTooltipPosition="above"
                        appendTo="body" icon="fa fa-xxx fa-trash" (click)="onDelete(ri,rowData)"></p-button> 
              </td>
                @for (col of columns; track col + '-'+ $index){
                <td pFrozenColumn
                [frozen]="col.frozen"
                alignFrozen="left"
                [style.left]="col.frozen ? $any(col).stickyLeft : ''"
                [style.background-color]="col.frozen ? '#e2f0d9' : null" >
                    @if(col.field !== 'fdid'){<span>{{rowData[col.field]}}</span>}
                    @if(col.field === 'fdid'){<a style="cursor: pointer" (click)="onClickGetFDIDDetails(rowData);">{{rowData[col.field]}}</a>}
                </td>}
            </tr>
        </ng-template>

        <ng-template pTemplate="paginatorright">
            <button  id="btn_fdid_export" 
            [matTooltip]="this.userService.enableFileExport()?
                    'Export':'Export service is disabled'"
            [matTooltipShowDelay]="1000" class="exportBtn"
            (click)="exportToCSV()" type="button">Export  <i class="fa fa-download" aria-hidden="true"></i> 
            @if(isExportToJSON){
            <img style="text-align:right" alt="Export to JSON"
            src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
            }</button>
            Total Records: {{totalRecords}}
        </ng-template>
        <ng-template pTemplate="paginatorleft">
            Showing {{fdidData.length == 0? 0 : startLimit + 1}} to {{fdidData.length
                          < rowcount ? fdidData.length < startLimit ? endLimit : fdidData.length : endLimit}} entries
        </ng-template>
    </p-table>
</div>
</div>
<!-- Quick View Panel Code  -->
 @if(viewFDID || addFDID){
<p-drawer id="sidebar_fdid_view" styleClass="u ui-sidebar-lg" [style]="{ 'width': 'auto', 'max-width': '500px', 'height': 'auto', 'overflow-y': 'auto', 'max-height': '100%'}" 
position="right" [(visible)]="displaySideBar" (onHide)="onClickCancelFDID()">
    <div class="ui-grid ui-grid-responsive ui-fluid">
        @if(selectedFDID){
        <div>
            <h3 class="ui-grid-col-12 textSize">FDID Details</h3>
            <div class="ui-grid-col-12">
                <div class="ui-grid-col-3 quick-view-grid-row">
                    <label for="CatReporterIMID">CatReporterIMID</label>
                </div>
                <div lass="ui-grid-col-9 quick-view-grid-row">
                    <input type="text" id="ip_fdid_catReporterIMID" ngDefaultControl [(ngModel)]="selectedFDID.catReporterIMID" [disabled]="viewFDID" />
                </div>
            </div>
            <div class="ui-grid-col-12">
                <div class="ui-grid-col-3 quick-view-grid-row">
                    <label for="AccountNumber">Account Number</label>
                </div>
                <div lass="ui-grid-col-9 quick-view-grid-row">
                    <input id="ip_fdid_accountNumber" type="text" ngDefaultControl [(ngModel)]="selectedFDID.accountNumber" [disabled]="viewFDID" />
                </div>
            </div>
            <div class="ui-grid-col-12">
                <div class="ui-grid-col-3 quick-view-grid-row">
                    <label for="Name">Name</label>
                </div>
                <div lass="ui-grid-col-9 quick-view-grid-row">
                    <input id="ip_fdid_name" type="text" ngDefaultControl [(ngModel)]="selectedFDID.name" [disabled]="viewFDID" />
                </div>
            </div>
            <div class="ui-grid-col-12">
                <div class="ui-grid-col-3 quick-view-grid-row">
                    <label for="GivenName">Given Name</label>
                </div>
                <div lass="ui-grid-col-9 quick-view-grid-row">
                    <input id="ip_fdid_givenname" type="text" ngDefaultControl [(ngModel)]="selectedFDID.givenName" [disabled]="viewFDID" />
                </div>
            </div>
                
            <div class="ui-grid-col-12">
                <div class="ui-grid-col-3 quick-view-grid-row">
                    <label for="ReceivedFDID">Received FDID</label>
                </div>
                <div lass="ui-grid-col-9 quick-view-grid-row">
                    <input id="ip_fdid_receivedfdid" type="text" ngDefaultControl [(ngModel)]="selectedFDID.receivedFDID" [disabled]="viewFDID || !checked" />
                    <p-checkbox ngDefaultControl [(ngModel)]="checked" binary="false" [disabled]="viewFDID" (click)="onCheckConfirm(checked)"></p-checkbox>
                </div>
            </div>
            <div class="ui-grid-col-12">
                <div class="ui-grid-col-3 quick-view-grid-row">
                    <label for="GeneratedFDID">Generated FDID</label>
                </div>
                <div lass="ui-grid-col-9 quick-view-grid-row">
                    <input id="ip_fdid_generatedFDID" type="text" ngDefaultControl [(ngModel)]="selectedFDID.generatedFDID" disabled />
                </div>
            </div>
            <div class="ui-grid-col-12">
                <div class="ui-grid-col-3 quick-view-grid-row">
                    <label for="Active">Active</label>
                </div>
                <div lass="ui-grid-col-9 quick-view-grid-row">
                    <input id="ip_fdid_active" type="text" ngDefaultControl [(ngModel)]="selectedFDID.active" [disabled]="viewFDID" />
                </div>
            </div>
            <div class="ui-grid-col-11">
                <p-button id="btn_cancel_fdid" type="button" (click)="onClickCancelFDID();" label="Close" class="ui-button-danger ui-grid-col-1 btn-style pull-right userActionBtn"></p-button>
            </div>
        </div>}
    </div>
</p-drawer>}

@if(isViewFDID){
<p-dialog id="viewFDID" [(visible)]="isViewFDID" header="" appendTo="body" height="auto" width="auto" [style]="{width: '90%', minWidth: '500px'}" [minY]="100" [maximizable]="true" minimizeIcon="pi pi-window-minimize" maximizeIcon="pi pi-window-maximize"
closeIcon="pi pi-times" [modal]="false" draggable="true">
    <div class="ui-grid-col-12 FDID-popup-div">
        <div class="text-center"><label for="CATFDID"><b>Firm A Reports the following to the CAT FDID and Account Information
                    System</b></label></div>
        <hr>
        <div class="row">
            <div class="ui-grid-col-4 quick-view-grid-row">
                <label for="AccountInfo"><b>Account Information for FDID #</b></label>{{ selectedFDID.fdid }}
            </div>
            <div class="ui-grid-col-3 quick-view-grid-row">
                <label for="FDIDType"><b>FDID Type</b></label> : {{ selectedFDID.fdidType }}
            </div>
            <div class="ui-grid-col-2 quick-view-grid-row">
                <label for="EffectiveDate"><b>Effective Date</b></label>: {{selectedFDID.effectiveDate }}
            </div>
        </div>
        <hr>
        @if(fdidData){
        <div class="row">
            <div class="row quick-view-grid-row">
                <label for="FDIDInformation"><b>FDID Information for FDID #</b></label>{{selectedFDID.fdid}}
            </div>
            <div class="row">
                <p-table [columns]="fdidColumns" [value]="selectedFDID.fdidDetails" #dt1 class="FDID-table-style">
                    <ng-template pTemplate="header" let-columns>
                        <tr>
                            @for (col of columns; track col;){
                            <th id="colHeader">
                                {{col.header}}
                            </th>}
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-rowData let-ri="rowIndex" let-columns="columns">
                        <tr [pSelectableRow]="rowData">
                            @for (col of columns; track col;){
                            <td>
                                {{rowData[col.field]}}
                            </td>}
                        </tr>
                    </ng-template>
                </p-table>
                <br>
            </div>
        </div>}
    </div>
    <ng-template #footer>
        <div class="ui-dialog-buttonpane ui-helper-clearfix">
            <p-button id="btn_close" type="button" icon="fa fa-close" [style]="{ 'background': '#e54a23 !important'}" class="userActionBtn" (click)="displayDialog=false;['edit=false']; ['view=false']; ['add=false'];" label="Close"></p-button>
        </div>
    </ng-template>
</p-dialog>}
@if(addFDID){
<app-add-fdid [showSideBar]="addFDID" (closeSideBar)="closeAddFDID($event)"></app-add-fdid>}
@if(editFDID){
<app-edit-fdid [displaySideBar]="editFDID" [selectedFDIDData]="selectedFDID" (closeSideBar)="closeEditFDID($event)" [autoCopied]="autoCopied"
[DefaultFilterArray]="DefaultFilterArray" [Limit]="Limit" (refreshData)="refreshFDIDData($event)"></app-edit-fdid> 
}

<p-confirmDialog id="fdidconfirmDialog" [style]="{width: '30vw',minHeight:'100px'}" appendTo="body"
showEffect="fade" focusOnShow="false" styleClass="fdid-confirmDialog"></p-confirmDialog>
